export default {
  topMenu: {
    openSettings: 'Abrir configurações',
    showAbout: 'Exibir informações gerais',
    about: 'Sobre o ORS',
    pinSidebar: 'Fixar barra lateral',
    settingsTooltip: 'Clique aqui se quiser ajustar configurações da aplicação'
  }
}
